<span
    class="header-name"
    (click)="toggleExpanded()"
>
    <app-ag-grid-group-header-text
        [name]="params.name"
        [columnGroup]="params.columnGroup"
    >
        <i [class]="expandedIcon"></i>
    </app-ag-grid-group-header-text>
</span>
